import { useQuery, UseQueryOptions } from "@oysterhr/core"
import { gql } from "@apollo/client"
import { QueryCompanyArgs, Company, PaymentsSettings, DocumentCollection } from "@oysterhr/schema"

export const COMPANY_PAYMENT_STATUS_SECTION_QUERY = gql`
  query StaffInvoicingPaymentStatusSection($companyId: ID!) {
    company(companyId: $companyId) {
      id
      paymentsSettings {
        flaggedAsFraudster
        restricted
        restrictedReason
        flaggedAsFraudsterReason
        automaticallyRemoveRestriction
        badDebtCategory
        restrictedAt
        restrictedBy {
          id
          name
        }
        authorizations {
          actions
          fields
        }
      }
      documents(tag: "NOB", perPage: 1) {
        collection {
          id
          createdAt
        }
      }
    }
  }
`

type QueryResponse = {
  company: Pick<Company, "id"> & {
    documents: DocumentCollection
    paymentsSettings: Pick<
      PaymentsSettings,
      | "flaggedAsFraudster"
      | "restricted"
      | "restrictedReason"
      | "flaggedAsFraudsterReason"
      | "automaticallyRemoveRestriction"
      | "restrictedAt"
      | "restrictedBy"
      | "badDebtCategory"
      | "authorizations"
    >
  }
}

export const useCompanyPaymentStatusQuery = (
  options?: UseQueryOptions<QueryResponse, QueryCompanyArgs>,
) => useQuery<QueryResponse, QueryCompanyArgs>(COMPANY_PAYMENT_STATUS_SECTION_QUERY, options)
